export const DELETE_DRAFT_PRIVATE_FORM = 'DELETE_DRAFT_PRIVATE_FORM';
export const GET_FORM_PRIVATE = 'GET_FORM_PRIVATE';
export const GET_FORM_PUBLIC = 'GET_FORM_PUBLIC';
export const GET_FORM_HEADERS_PRIVATE = 'GET_FORM_HEADERS_PRIVATE';
export const GET_FORM_HEADERS_PUBLIC = 'GET_FORM_HEADERS_PUBLIC';
export const SAVE_DRAFT_PRIVATE_FORM = 'SAVE_DRAFT_PRIVATE_FORM';
export const SUBMIT_FORM_PRIVATE = 'SUBMIT_FORM_PRIVATE';
export const SUBMIT_FORM_PUBLIC = 'SUBMIT_FORM_PUBLIC';



// WEBPACK FOOTER //
// ./src/actions/forms/types.js